// WordRotator.tsx
import React, { useEffect, useState } from "react";
import "./wordRotator.css";

export default function WordRotator({ words, wrapperstyles, textstyles }) {
	const [index, setIndex] = useState(0);
	const [prevIndex, setPrevIndex] = useState(null);

	useEffect(() => {
		const interval = setInterval(() => {
			setPrevIndex(index);
			setIndex((prev) => (prev + 1) % words.length);
		}, 2000);

		return () => clearInterval(interval);
	}, [index, words.length]);

	return (
		<div className={`word-rotator-container ${wrapperstyles}`}>
			{prevIndex !== null && (
				<div key={`out-${prevIndex}`} className={`${textstyles} word out`}>
					{words[prevIndex]}
				</div>
			)}
			<div key={`in-${index}`} className={`${textstyles} word in`}>
				{words[index]}
			</div>
		</div>
	);
}
